/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { TRIGGER } from './constants'

export function parseTriggerNameOrRoles(
  isForSelect: boolean,
  data: string[] | undefined
): Array<{ label: string; value: string }> | string[] {
  if (!data || !Array.isArray(data)) {
    return []
  }

  if (isForSelect) {
    return data.map((item) => ({
      label: item,
      value: item
    }))
  }

  return data
}

export function getSubTriggerNameOrPH(value: string, isPH: boolean): string {
  if (isPH) {
    switch (value) {
      case TRIGGER.TEAMS:
        return 'AUTO_APPLY_PACKAGE_TRIGGER_TEAM_MEMBER_PH'
      case TRIGGER.VISITS:
        return 'AUTO_APPLY_PACKAGE_TRIGGER_TEAM_VISIT_TYPE_PH'
      case TRIGGER.MILESTONES:
        return 'AUTO_APPLY_PACKAGE_TRIGGER_CTMS_MILESTONES_PH'
      default:
        return ''
    }
  } else {
    switch (value) {
      case TRIGGER.TEAMS:
        return 'AUTO_APPLY_PACKAGE_TRIGGER_TEAM_MEMBER'
      case TRIGGER.VISITS:
        return 'AUTO_APPLY_PACKAGE_TRIGGER_VISIT_TYPE'
      case TRIGGER.MILESTONES:
        return 'AUTO_APPLY_PACKAGE_TRIGGER_CTMS_MILESTONES'
      default:
        return ''
    }
  }
}
